import { combineReducers } from 'redux';

import stack from './stack';

/**
 * @typedef {{
 *  stack: import('./stack').State
 * }} AuditModelUISelectReducer
 */

export default combineReducers({
  stack,
});
